// import plugins
import http from './http'
import maps from './maps/maps'
import toast from './toast'
import dayOfWeek from './day-of-week'
import moment from 'moment'
import MBLoading from './mbloading'

/**
 * Default export.
 *
 * @param Vue
 * @param store
 * @param router
 */
export default (Vue, store, router) => {
  // setup http
  Vue.use(http, { store, router })

  // setup toast
  Vue.use(toast, {router})
  Vue.use(MBLoading)
  Vue.use(MBLoading, {
    dark: true, // default false
    text: 'Processando...', // default 'Loading'
    loading: true, // default false
    customLoader: '', // replaces the spinner and text with your own
    background: 'rgb(255,255,255)', // set custom background
    classes: ['myclass'] // array, object or string
  })

  maps(Vue)

  Vue.prototype.$dayOfWeek = dayOfWeek
  Vue.prototype.$moment = moment
}



// WEBPACK FOOTER //
// ./src/plugins/index.js